import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "skeleton-pill"
};
const _hoisted_2 = { key: 1 };
const _hoisted_3 = { key: 2 };
const _hoisted_4 = { key: 3 };
const _hoisted_5 = {
    key: 0,
    class: "skeleton-pill-small"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = { key: 0 };
const _hoisted_8 = {
    key: 0,
    class: "skeleton-chips"
};
const _hoisted_9 = {
    key: 1,
    class: "obscured-card-row"
};
const _hoisted_10 = { class: "obscured-card-left" };
const _hoisted_11 = { class: "obscured-merchant" };
const _hoisted_12 = { class: "obscured-balance" };
const _hoisted_13 = { key: 0 };
const _hoisted_14 = { class: "obscured-card-right" };
const _hoisted_15 = ["src"];
import { ref, computed, onMounted } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'VoucherCard',
    props: {
        voucher: {},
        formatter: {},
        obscured: { type: Boolean },
        cardCount: {},
        totalGroupAmount: {},
        wallet: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const voucherCardBackground = ref(null);
        const voucherCardTextColor = ref(null);
        const formattedCategory = computed(() => {
            const category = props.voucher.discount.merchant.categories.split(',')[0];
            return category.split('-').map((word) => {
                return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
            }).join(' ');
        });
        const formattedExpiryDate = computed(() => {
            const date = new Date(props.voucher.expiryDateTime);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}.${month}.${year}`;
        });
        const cardBackgroundColor = computed(() => {
            return voucherCardBackground.value || 'var(--background-color-vourcher-default)';
        });
        function getTextColorForBackground(bg) {
            let r = 0, g = 0, b = 0;
            if (bg.startsWith('rgb')) {
                const matches = bg.match(/\d+/g);
                if (matches) {
                    [r, g, b] = matches.map(Number);
                }
            }
            else if (bg.startsWith('#')) {
                if (bg.length === 7) {
                    r = parseInt(bg.slice(1, 3), 16);
                    g = parseInt(bg.slice(3, 5), 16);
                    b = parseInt(bg.slice(5, 7), 16);
                }
            }
            const brightness = (r * 299 + g * 587 + b * 114) / 1000;
            return brightness > 200 ? 'var(--text-color)' : 'var(--light-text-color)';
        }
        function setVoucherCardColors() {
            const v = props.voucher;
            if (v && v.isSkeleton) {
                voucherCardBackground.value = v.discount.cardColour || 'var(--background-color-vourcher-default)';
                voucherCardTextColor.value = '#ffffff';
            }
            else if (v && v.discount) {
                if (v.discount.cardColour) {
                    voucherCardBackground.value = v.discount.cardColour;
                    voucherCardTextColor.value = getTextColorForBackground(voucherCardBackground.value);
                }
                else if (v.discount.cardUrl) {
                    voucherCardBackground.value = 'var(--background-color-vourcher-default)';
                    voucherCardTextColor.value = 'var(--light-text-color)';
                }
            }
            else {
                voucherCardBackground.value = 'var(--background-color-vourcher-default)';
                voucherCardTextColor.value = 'var(--light-text-color)';
            }
        }
        onMounted(() => {
            setVoucherCardColors();
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_chip = _resolveComponent("v-chip");
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass('card ' + (_ctx.wallet ? 'wallet' : '')),
                style: _normalizeStyle({ backgroundColor: cardBackgroundColor.value, color: voucherCardTextColor.value || 'var(--light-text-color)' })
            }, [
                (!_ctx.obscured)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createVNode(_component_v_row, { class: "nameRow" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, { class: "v-col-9 nameCol" }, {
                                    default: _withCtx(() => [
                                        (_ctx.voucher.isSkeleton)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_1))
                                            : (_openBlock(), _createElementBlock("p", _hoisted_2, [
                                                _createElementVNode("b", null, _toDisplayString(_ctx.voucher.discount.merchant.name), 1)
                                            ])),
                                        (_ctx.cardCount && !_ctx.voucher.isSkeleton)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.cardCount) + " vouchers", 1))
                                            : (!_ctx.voucher.isSkeleton)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(formattedCategory.value), 1))
                                                : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                }),
                                _createVNode(_component_v_col, { class: "right" }, {
                                    default: _withCtx(() => [
                                        (_ctx.voucher.isSkeleton)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                                            : (_openBlock(), _createElementBlock("img", {
                                                key: 1,
                                                class: "bankLogo",
                                                src: _ctx.voucher.discount.merchant.logoUrl
                                            }, null, 8, _hoisted_6))
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_row, { class: "mt-0" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, { class: "balanceCol" }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.formatter.format(_ctx.totalGroupAmount !== null && _ctx.totalGroupAmount !== undefined ? _ctx.totalGroupAmount : _ctx.voucher.currentBalance, false, false)), 1)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_row, { class: "mt-1 mb-4" }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_col, { class: "labelCol" }, {
                                    default: _withCtx(() => [
                                        (!_ctx.voucher.isSkeleton)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Balance"))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_v_row, { class: "mt-5" }, {
                            default: _withCtx(() => [
                                (!_ctx.voucher.isSkeleton)
                                    ? (_openBlock(), _createBlock(_component_v_col, {
                                        key: 0,
                                        cols: "5",
                                        class: "tp-4"
                                    }, {
                                        default: _withCtx(() => [
                                            _cache[0] || (_cache[0] = _createTextVNode("Exp. ")),
                                            _createElementVNode("b", null, _toDisplayString(formattedExpiryDate.value), 1)
                                        ]),
                                        _: 1
                                    }))
                                    : (_openBlock(), _createBlock(_component_v_col, {
                                        key: 1,
                                        cols: "5",
                                        class: "tp-4"
                                    }, {
                                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                                            _createElementVNode("div", { class: "skeleton-pill-small" }, null, -1)
                                        ])),
                                        _: 1
                                    })),
                                _createVNode(_component_v_col, { class: "right no-top-padding" }, {
                                    default: _withCtx(() => [
                                        (_ctx.voucher.isSkeleton)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[2] || (_cache[2] = [
                                                _createElementVNode("div", { class: "skeleton-pill-small" }, null, -1),
                                                _createElementVNode("div", { class: "skeleton-pill-small" }, null, -1)
                                            ])))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                (_ctx.voucher.discount.online)
                                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                                        key: 0,
                                                        size: "small",
                                                        "background-color": "blue"
                                                    }, {
                                                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                            _createTextVNode("Online")
                                                        ])),
                                                        _: 1
                                                    }))
                                                    : _createCommentVNode("", true),
                                                _cache[5] || (_cache[5] = _createTextVNode()),
                                                (_ctx.voucher.discount.inStore)
                                                    ? (_openBlock(), _createBlock(_component_v_chip, {
                                                        key: 1,
                                                        size: "small"
                                                    }, {
                                                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                                                            _createTextVNode("In Store")
                                                        ])),
                                                        _: 1
                                                    }))
                                                    : _createCommentVNode("", true)
                                            ], 64))
                                    ]),
                                    _: 1
                                })
                            ]),
                            _: 1
                        })
                    ], 64))
                    : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.voucher.discount.merchant.name), 1),
                            _createElementVNode("div", _hoisted_12, [
                                _createTextVNode(_toDisplayString(_ctx.formatter.format(_ctx.totalGroupAmount !== null && _ctx.totalGroupAmount !== undefined ? _ctx.totalGroupAmount : _ctx.voucher.currentBalance, false, false)) + " ", 1),
                                (_ctx.cardCount)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, " (" + _toDisplayString(_ctx.cardCount) + " vouchers)", 1))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("img", {
                                class: "bankLogo",
                                src: _ctx.voucher.discount.merchant.logoUrl
                            }, null, 8, _hoisted_15)
                        ])
                    ]))
            ], 6));
        };
    }
});
